import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import { Material } from './Material.js';
import { Color } from '../math/Color.js';
/**
 * parameters = {
 *  color: <hex>,
 *  map: new THREE.Texture( <Image> ),
 *  alphaMap: new THREE.Texture( <Image> ),
 *  rotation: <float>,
 *  sizeAttenuation: <bool>
 * }
 */

var SpriteMaterial = /*#__PURE__*/function (_Material) {
  _inheritsLoose(SpriteMaterial, _Material);

  function SpriteMaterial(parameters) {
    var _this;

    _this = _Material.call(this) || this;
    _this.type = 'SpriteMaterial';
    _this.color = new Color(0xffffff);
    _this.map = null;
    _this.alphaMap = null;
    _this.rotation = 0;
    _this.sizeAttenuation = true;
    _this.transparent = true;

    _this.setValues(parameters);

    return _this;
  }

  var _proto = SpriteMaterial.prototype;

  _proto.copy = function copy(source) {
    _Material.prototype.copy.call(this, source);

    this.color.copy(source.color);
    this.map = source.map;
    this.alphaMap = source.alphaMap;
    this.rotation = source.rotation;
    this.sizeAttenuation = source.sizeAttenuation;
    return this;
  };

  return SpriteMaterial;
}(Material);

SpriteMaterial.prototype.isSpriteMaterial = true;
export { SpriteMaterial };